import { useAuth } from '@/contexts/AuthContext'

export default function SchoolOverview() {
  const { profile } = useAuth()

  return (
    <div>
      <div style={{ font: '600 26px Lora, serif', color: '#1B2A4A', marginBottom: 6 }}>
        School overview
      </div>
      <div style={{ font: '400 14px Inter, sans-serif', color: 'rgba(27,42,74,0.55)', marginBottom: 28 }}>
        Welcome back, {profile?.full_name ?? 'Admin'}
      </div>

      {/* Placeholder stat cards */}
      <div className='g4stat' style={{ marginBottom: 28 }}>
        {[
          { label: 'Instructors', value: '—' },
          { label: 'Active students', value: '—' },
          { label: 'Mock tests this week', value: '—' },
          { label: 'Certificates issued', value: '—' },
        ].map(stat => (
          <div key={stat.label} style={{
            background: 'linear-gradient(155deg, #0F7C6C, #0B5D51)',
            borderRadius: 12, padding: '18px 20px',
          }}>
            <div style={{ font: '700 28px Lora, serif', color: '#fff' }}>{stat.value}</div>
            <div style={{ font: '400 12.5px Inter, sans-serif', color: 'rgba(255,255,255,0.75)', marginTop: 4 }}>{stat.label}</div>
          </div>
        ))}
      </div>

      <div className='banner-info'>
        School portal is ready. Curriculum, instructor management, and reporting will be wired up in Phase 2.
      </div>
    </div>
  )
}
